import { axios } from '@/utils/request'

const api = {
  installLabel: '/master/installLabel',
}

export function queryInstallLabel (parameter) {
  return axios({
    url: api.installLabel + '/queryInstallLabel',
    method: 'get',
    params: parameter
  })
}

export function selectALLInstallLabel (parameter) {
  return axios({
    url: api.installLabel + '/selectALLInstallLabel',
    method: 'get',
    params: parameter
  })
}

// export function addInstallLabel (parameter) {
//   return axios({
//     url: api.installLabel + '/addInstallLabel',
//     method: 'post',
//     data: parameter,
//     headers: {
//       'Content-Type': 'application/json;charset=UTF-8'
//     }
//   })
// }
//
// export function editInstallLabel (parameter) {
//   return axios({
//     url: api.installLabel + '/editInstallLabel',
//     method: 'post',
//     data: parameter,
//     headers: {
//       'Content-Type': 'application/json;charset=UTF-8'
//     }
//   })
// }

export function saveInstallLabel (parameter) {
  return axios({
    url: api.installLabel + (parameter.installLabelId == 0 ? '/addInstallLabel' : '/editInstallLabel'),
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

//禁用
export function forbiddenInstallLabel (parameter) {
  return axios({
    url: api.installLabel + '/forbiddenInstallLabel',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

//启动
export function enableInstallLabel (parameter) {
  return axios({
    url: api.installLabel + '/enableInstallLabel',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function deleteInstallLabel (parameter) {
  return axios({
    url: api.installLabel + '/deleteInstallLabel',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export const accessoryExport = api.accessory + '/export'